export default {
  mounted() {
    this.__lastOnShowTime = 0;
    this.__onShowThrottle = 3000;
    window.addEventListener('focus', this.__handleOnShow);
    document.addEventListener('visibilitychange', this.__handleOnShow);
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.__handleOnShow);
    document.removeEventListener('visibilitychange', this.__handleOnShow);
  },
  deactivated() {
    window.removeEventListener('focus', this.__handleOnShow);
    document.removeEventListener('visibilitychange', this.__handleOnShow);
  },
  methods: {
    __handleOnShow() {
      if (document.visibilityState !== 'visible') return;
      const now = Date.now();
      if (now - this.__lastOnShowTime > this.__onShowThrottle) {
        this.__lastOnShowTime = now;
        if (typeof this.onShow === 'function') {
          this.onShow();
        }
      }
    }
  }
};
